import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const fetchPOStatusList = createAsyncThunk("fetchPOStatusList", async ({ channelId }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`channel/${channelId}/po-status`);
		return response.data;
	} catch (err) {
		if (!err.response) throw err;
		return rejectWithValue(err.response.data);
	}
});

const RewardsPOStatusListSlice = createSlice({
	name: "RewardsPOStatusListSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPOStatusListState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchPOStatusList.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(fetchPOStatusList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(fetchPOStatusList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPOStatusListState } = RewardsPOStatusListSlice.actions;
export default RewardsPOStatusListSlice.reducer;
